export const sendToParent = (action, payload) => {
  window.parent.postMessage({ action, payload }, "*");
};
